import React from "react";
import Img1 from "../../../assets/images/IZB/IZB Website Skin/Home_Page/New/1.png";
import { Link } from "react-router-dom";

const TermLoanCard = () => {
  const img = {
    backgroundImage: `url(${Img1})`,
    height: "280px",
    width: "270px",
  };
  return (
    <div style={img} className="col-3 vertical-slider-card">
      
      <div className="text-white p-3" style={{textAlign:"left"}}>
        <h4 className="text-white">Term Loan</h4>
        <p className="text-0" >
          Access our long and short-term loans designed to meet your specific
          funding requirements.
        </p>
      </div>
      <div className="button-box text-center d-flex justify-content-center p-3">
        <Link to="/TermLoan">
          <button
            className="btn-one p-1 mt-5"
            style={{ lineHeight: "30px" }}
            type="submit"
          >
            <span className="txt">Create Account</span>
          </button>
        </Link>
      </div>
    </div>
  );
};

export default TermLoanCard;
